import { useTranslation } from 'react-i18next';
import posterIt from '../static/images/app_download_IT.jpg';
import posterEn from '../static/images/app_download_EN.jpg';
import posterDe from '../static/images/app_download_DE.jpg';
import posterFr from '../static/images/app_download_FR.jpg';

// Link store ufficiali (vedi CLAUDE.md → Stato pubblicazione).
export const APP_STORE_URL = 'https://apps.apple.com/app/ticinowild-app/id6761824063';
export const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=ch.ticinowild.mobile';

// Poster localizzato: una variante per lingua, fallback italiano (coerente con i18n).
const POSTERS = { it: posterIt, en: posterEn, de: posterDe, fr: posterFr };

// Poster promo "Scarica l'app di TicinoWild": titolo, mockup e badge store sono DISEGNATI
// nell'immagine. I due badge diventano cliccabili tramite overlay <a> posizionati in
// percentuale (misurati sui file 1486×1922; fra le lingue i badge slittano di ~1%,
// gli overlay hanno margine sufficiente a coprire tutte le varianti).
// Usato dalla sezione in homepage (DownloadAppFromStore) e dalla landing /app.
function DownloadAppPoster({ className = '' }) {
    const { t, i18n } = useTranslation();
    const lang = (i18n.language || 'it').split('-')[0];
    const poster = POSTERS[lang] || POSTERS.it;

    return (
        <div className={`relative ${className}`}>
            <img
                src={poster}
                alt={t('Homepage.DownloadAppFromStore.title')}
                className='w-full h-auto rounded-xl shadow-md'
            />
            <a
                href={APP_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('Homepage.DownloadAppFromStore.appStoreAria')}
                className='absolute'
                style={{ left: '26%', top: '89.5%', width: '23.5%', height: '6.5%' }}
            />
            <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={t('Homepage.DownloadAppFromStore.googlePlayAria')}
                className='absolute'
                style={{ left: '50.2%', top: '89.5%', width: '23.5%', height: '6.5%' }}
            />
        </div>
    );
}

export default DownloadAppPoster;
